/**
 * This is a cache for object urls of blobs, when we want to load a video we download the video and create a blob
 *
 * Once the blob is created we store it as an object url here and so that it can be used on subsequent loads of the video and is more performant
 */
export const blobUrlCache: Record<string, string> = {}
